import React, {useEffect, useState} from 'react'
import './App.css'

import FixedTopHeader from './Header/FixedTopHeader'
import IslandSlider from './Components/IslandSlider'
import CustomGoogleMap from './Components/GoogleMap'
import ContactForm from './Components/ContactForm'
import OverlayMenu from './Components/OverlayMenu'

var awsPrefix = "https://res302.s3-us-west-2.amazonaws.com/outer201/sailingthegreen/"

var team = [
  {img: "mira", display: "Mira", desc: "Admin"},
  {img: "ashwin", display: "Ashwin", desc: "Marketing"},
  {img: "phil", display: "Phil", desc: "Skipper"},
  {img: "nathan", display: "Nathan", desc: "Special Ops"},
  {img: "jordan", display: "Jordan", desc: "Vibes"},
  {img: "jaime", display: "Jaime", desc: "Ecology"},
]

function App() {
   var [darkenHeader, updateDarkenHeader] = useState(false), [menuOpen, toggleMenuOpen] = useState(false);

   const listener = e => {
      if(window.pageYOffset > 10 && !darkenHeader){updateDarkenHeader(true)} else if (window.pageYOffset < 10 && darkenHeader){updateDarkenHeader(false)}
   };

   useEffect(() => {window.addEventListener("scroll", listener); return () => {window.removeEventListener("scroll", listener)}});

  return (
      <div className={`FlexContainer FullWidth Column AutoHeight`} id="home">
        <FixedTopHeader darkenHeader={darkenHeader} menuOpen={menuOpen} toggleMenuOpen={toggleMenuOpen}/>

        {menuOpen && <OverlayMenu toggleMenuOpen={toggleMenuOpen} awsPrefix={awsPrefix} />}

        <div className={`FlexContainer Height85 Height85-MB FullWidth Column JustifyCentre AlignCentre BackgroundOne-Green`}>

          <img src={`${awsPrefix}icons/simpleIconWhite.png`} alt="Sailing the green logo" className={`MainLogo HeightInitial`} />

          <h1 className={`TextCentre White Width80 SpaceBelowX2 SpaceAboveX4-MB`}>Seas the day</h1>
          <h2 className={`TextCentre White Width80 LineBreakAbove White Space SpaceBelowX2`}>Conserve and Sustain</h2>
        </div>

        <div className={`FlexContainer Height85 FullWidth Column`} id="about">
          <h2 className={`SpaceAbove10 TextCentre`}>What we do</h2>

          <p className={`Width80 MarginAuto TextCentre SpaceAboveX4`}>Aotearoa, Land of the long white cloud, middle earth – whichever variation of the name you use, New Zealand is known for its pristine waters, unique flora and fauna, and distinct bird and wild life.
          <br /><br />
          Many travellers who visit Auckland may only experience the islands surrounding Auckland by taking photos from the city or passing by them on a ferry, never getting to see the true beauty of nature, which lies within convenient touching distance of the country’s biggest city.
          <br /><br />
          Sailing The Green – a venture built on its love for the environment, sense of adventure, and a desire to leave a positive and lasting impact in its surroundings – offers a full and immersive kiwi experience like no other.From volcanic Islands to rolling farmland with white sand beaches, our trips have a special emphasis on maintaining and improving the native flora and fauna on these islands.
          <br /><br />
          Revelation has capacity for 20 day passengers and 10 overnight guests. We cater for individuals or groups and run regular trips to the Gulf islands where guests are encouraged to get involved with conservation efforts. Register for more info.</p>
        
          <div className={`FlexContainer RowToColumn SpaceBetween SpaceAboveX8`}>
            <img src={`${awsPrefix}bg/boat-1.jpg`} alt="Sailing the green logo" className={`SquareImage`} />
            <img src={`${awsPrefix}bg/boat-2.jpg`} alt="Sailing the green logo" className={`SquareImage`} />
            <img src={`${awsPrefix}bg/boat-3.jpg`} alt="Sailing the green logo" className={`SquareImage`} />
            <img src={`${awsPrefix}bg/boat-4.jpg`} alt="Sailing the green logo" className={`SquareImage`} />
          </div>
        </div>

        <div className={`FlexContainer Height85 FullWidth Column LightGreyBackground`}>
           <h2 className={`SpaceAbove10 TextCentre Width80-MB`}>Hauraki Gulf Islands</h2>

           <IslandSlider awsPrefix={awsPrefix}/>
        </div>

        <div className={`FlexContainer Height85 FullWidth Column`} id="technology">
           <h2 className={`SpaceAbove10 TextCentre`}>Technology</h2>

           <p className={`TextCentre SpaceAboveX2 Width80-MB`}>Sailing the Green walks the talk: -
           <br /><br />
            Revelations’ tender is powered by an emission-free electric outboard motor<br />
            On-board power is provided by solar panels and a wind generator<br />
            Full electric propulsion for Revelation is in development</p>

          <div className={`FlexContainer RowToColumn SpaceBetween SpaceAboveX8`}>
            <img src={`${awsPrefix}tech/tech-1.jpg`} alt="Sailing the green logo" className={`SquareImage`} />
            <img src={`${awsPrefix}tech/tech-2.jpg`} alt="Sailing the green logo" className={`SquareImage`} />
            <img src={`${awsPrefix}tech/tech-3.jpg`} alt="Sailing the green logo" className={`SquareImage`} />
            <img src={`${awsPrefix}tech/tech-4.jpg`} alt="Sailing the green logo" className={`SquareImage`} />
          </div>
        </div>

        <div className={`FlexContainer FullWidth Column`} id="team">
           <h2 className={`SpaceAbove10 TextCentre`}>Our Team</h2>

          <div className={`FlexContainer RowToColumn SpaceBetween SpaceAboveX8 SpaceRightX8 SpaceLeftX8`}>
            {team.map(({img, display, desc}) =>
                <div className={`FlexContainer Column Flex SpaceLeftX2 SpaceRightX2 SpaceBelowX2-MB AlignCentre`} key={img}>
                  <img src={`${awsPrefix}team/team-${img}.jpg`} alt="Sailing the green logo" className={`Width100`}/>
                  <h3 className={`SpaceAboveX2`}>{display.toUpperCase()}</h3>
                  <p className={`SpaceAbove`}>{desc.toUpperCase()}</p>
                </div>)}
          </div>
        </div>

         <div className={`FlexContainer FullWidth RowToColumn LightGreyBackground SpaceAboveX8`} id="contact">
            <ContactForm/>

            <div className={`FlexContainer Flex Column SpaceAboveX4`}>
               <CustomGoogleMap 
                  id={'GoogleMap'} 
                  options={{center: { lat: -36.842279, lng: 174.7504804 }, zoom: 15 }}/>
            </div>
         </div>


        <div className={`FlexContainer FullWidth Column DarkBackground AlignCentre`}>

          <p className={`TextCentre InheritColour BoldText SpaceAboveX8 Width80`}>Check out our Facebook page for events and latest happenings. Like our page and receive all updates by email.</p>

          <p className={`TextCentre InheritColour BoldText SpaceAboveX4 Width80`}>E-mail: <a className={`InheritColour`} href={'mailto:info@sailingthegreen.co.nz'}>info@sailingthegreen.co.nz</a> | Mobile: 021 298 4207</p>

          <a target="_blank" rel="noopener noreferrer" className={`FacebookCircle SpaceAboveX4 Width80`} href="https://www.facebook.com/rockingboat/">f</a>

          <label className={`ExtraSmall TextCentre InheritColour BoldText SpaceAboveX4 SpaceBelowX8 Width80`}>&copy; Copyright Sailing the Green 2020</label>
        </div>

      </div>  
  );
}

export default App;
